import SettingsCard from "../common/settings-card";
import VoiceSetting from "./voice-setting";
import VoiceSpeedSetting from "./voice-speed-setting";
import AmbientNoiseSetting from "./ambient-noise-setting";
import { memo } from "react";

const VoiceSettings = () => {
  return (
    <SettingsCard>
      <VoiceSetting />

      <VoiceSpeedSetting />

      <AmbientNoiseSetting />
    </SettingsCard>
  );
};

export default memo(VoiceSettings);
